/* One quiet reading moment; manuscript text and commerce remain untouched. */
(function(){
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 document.querySelectorAll('.hfm-coffee p').forEach(function(p){
  var text=p.textContent,fragment=document.createDocumentFragment(),i=0;
  text.split(/(\s+)/).forEach(function(word){
   if(!word.trim()){fragment.appendChild(document.createTextNode(word));return;}
   var span=document.createElement('span');span.className='hfm-reveal-word';span.textContent=word;span.style.transitionDelay=Math.min(i++*25,500)+'ms';fragment.appendChild(span);
  });
  p.replaceChildren(fragment);p.classList.add('hfm-reveal-armed');
  var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-in');observer.unobserve(entry.target);}});},{threshold:.6});
  p.querySelectorAll('.hfm-reveal-word').forEach(function(word){observer.observe(word);});
 });
})();
